import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import { Tabs, Tab } from "@mui/material";
import BillApprovalTable from "components/billDetailsApproval/BillApprovalTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import useFilter from "hooks/useFilter";
import { useState, useEffect, useContext } from "react";
import BillApprovalServices from "services/BillApprovalServices";
import Somethingwentwrong from "pages/Somethingwentwrong";
import { SidebarContext } from "context/SidebarContext";
import sidebar from "routes/sidebar";
import LabelArea from "components/form/LabelArea";
import InputSearchDate from "components/form/InputSearchDate";
import { useLocation } from "react-router-dom";
import ExportDataXlsx from "components/common/ExportDataXlsx";

const BillApproval = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;

  const [loading, setLoading] = useState(false);
  const { isUpdate, setIsUpdate } = useContext(SidebarContext);
  const [itemsPerPage, setItemsperpage] = useState(10);
  const [tab, setTab] = useState(0);
  const [error, setError] = useState(false);
  const [billapprovalData, setBillApprovalData] = useState([]);
  // const [paymentStatus, setPaymentStatus] = useState("unpaid");
  const [status, setStatus] = useState(false);
  const {
    billapprovalRef,
    dataTable,
    serviceData,
    handleSubmitBillApproval,
    //   currentPage,
  } = useFilter(billapprovalData, itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsperpage(serviceData.length);
    }
  }, [serviceData]);

  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const formattedDates = {
    start_date: searchstartDate ? formatDate(searchstartDate) : "",
    end_date: searchendDate ? formatDate(searchendDate) : "",
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const urlType = params.get("type");
    if (urlType !== null) {
      const parsed = Number(urlType);
      if (!isNaN(parsed) && parsed >= 1 && parsed <= 4) {
        setTab(parsed - 1);
      }
    }

    const start = params.get("start");
    const end = params.get("end");

    if (start && end) {
      const parseDate = (str) => {
        const [dd, mm, yyyy] = str.split("-");
        return new Date(yyyy, mm - 1, dd);
      };

      setSearchStartDate(parseDate(start));
      setSearchEndDate(parseDate(end));
    }
  }, [location.search]);

  useEffect(() => {
    const fetchBillApproval = async () => {
      setLoading(true);
      var date = {
        from: formattedDates.start_date,
        to: formattedDates.end_date,
      };
      try {
        let response;

        let payload = {
          // employee_id: adminInfo?.id,
          type: 1,
          from: date.from,
          to: date.to,
        };

        if (tab === 1) {
          payload.type = 2;
        } else if (tab === 2) {
          payload.type = 3; // Assuming type 3 for tab 2
        }
        response = await BillApprovalServices.billapprovalList(payload);

        const updatedData =
          response?.data?.map(
            ({
              ref_no,
              client_name,
              start_date,
              bill_amount,
              approval_status,
              vendor_id,
              ...rest
            }) => ({
              ref_no,
              client_name,
              start_date,
              bill_amount,
              approval_status,
              vendor_id,
              ...rest,
            }),
          ) || [];

        setBillApprovalData(updatedData);
        setItemsperpage(updatedData.length + 1);
        setStatus(response?.status);
      } catch (error) {
        setError(true);
        console.error("Error fetching billapproval:", error);
        setStatus(false);
      } finally {
        setLoading(false);
      }
    };

    if (!isUpdate && location.search && !searchstartDate && !searchendDate) {
      // console.log("Skipping initial fetch — waiting for URL date parsing");
      return;
    }

    fetchBillApproval();
    setIsUpdate(false);

    // eslint-disable-next-line
  }, [tab, isUpdate, searchstartDate, searchendDate]);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const handleSearch = () => {
    setIsUpdate(true);
  };
  const currentPage = 1;
  const isAdmin = adminInfo?.id === 1;
  const hideView = adminInfo?.permission?.find(
    (perm) => perm.id_tab === "bill details approval",
  )?.view;

  // const hideEdit = adminInfo?.permission?.find(
  //   (perm) => perm.id_tab === 'bill details approval'
  // )?.edit;

  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bill details approval" && perm.edit === 1,
      );
  // console.log('hideView:', hideView);
  // console.log('hideEdit:', hideEdit);

  // console.log('hideView:', adminInfo?.permission);
  // console.log('hideEdit:', hideEdit);

  // 	const filteredData = serviceData.reduce((filtered, term) => {
  //   return filtered.filter((search) =>
  //     [
  //       search?.ref_no,
  //       search?.client_name,
  //       search?.start_date,
  //       search?.arrival,
  //       search?.departure,
  //       search?.vendor_name,
  //       search?.TDS,
  //       search?.trip_advance_request,
  //       search?.trip_advance_paid,
  //       search?.bill_amount,
  //       search?.days_difference,
  //     ]
  //       .filter(Boolean)
  //       .some((value) =>
  //         value.toString().toLowerCase().includes(term)
  //       )
  //   );
  // }, serviceData);
  // console.log(filteredData)

  const finalData = dataTable.map((item, index) => ({
    "Sl. No.": index + 1,
    "Reference No.": item?.ref_no || "",
    "Client Name": item?.client_name || "",
    "Travel Start Date": item?.start_date || "",
    "Travel End Date": item?.end_date || "",
    Arrival: item?.arrival || "",
    Departure: item?.departure || "",
    "Vehicle Type": item?.vehicle_type || "",
    Transporter: item?.vendor_name || "",

    "Trip Advance Requested": item?.trip_advance_request || 0,
    "Trip Advance Paid": item?.trip_advance_paid || 0,

    "Approval Status": item?.approval_status || "",
    // "Payment Status": item?.paid_status || "",
    "Payment Date": item?.payment_date || "",
    // "UTR No.": item?.utr || "",
    "Payment Type": item?.payment_type || "",
    "Payment Remark": item?.paid_remark || "",

    "Bill Amount": item?.bill_amount || 0,
    "TDS Amount": item?.TDS || 0,
    "Remaining Payable Amount": item?.remaining_individual_amt || 0,
    "Bill Adjusted Amount": item?.bill_adjusted_amount || 0,
    "Bill Adjustment Remark": item?.bill_adjusted_remark || "",

    "No. of Days": item?.no_of_days || 0,
    // "Total KM": item?.total_km || 0,
    "Bill Added Days": item?.days_difference || 0,
  }));

  const getTabName = () => {
    switch (tab) {
      case 0:
        return " - Unapproved";
      case 1:
        return " - Approved";
      case 2:
        return " - All";
      default:
        return "";
    }
  };

  return (
    <>
      {hideView && (
        <>
          <PageTitle sidebar={sidebar().sidebar} />
          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800">
            <CardBody>
              <div className="flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-2">
                    <LabelArea label="From" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchstartDate}
                        onChange={(event) => setSearchStartDate(event)}
                      />
                    </div>
                  </div>

                  <div className="flex items-center gap-2">
                    <LabelArea label="To" />
                    <div className="w-50">
                      <InputSearchDate
                        value={searchendDate}
                        min={searchstartDate}
                        onChange={(event) => setSearchEndDate(event)}
                      />
                    </div>
                  </div>
                </div>

                <div className="flex-1">
                  <Input
                    ref={billapprovalRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    placeholder="Quick Search"
                    onChange={handleSubmitBillApproval}
                  />
                </div>

                <Button
                  className="rounded-md h-10 px-8"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </Button>

                <div className="">
                  <ExportDataXlsx
                    title="Bill Detail Approval"
                    exportDataXlsx={finalData}
                    fileNames={`Bill Detail Approval${getTabName()}`}
                    startDate={searchstartDate}
                    endDate={searchendDate}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
          <Tabs
            value={tab}
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { backgroundColor: "#057a55" },
            }}
            sx={{
              "& .MuiTab-root": {
                textTransform: "capitalize",
              },
            }}
          >
            {/* <Tab label="All" /> */}
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Unapproved"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="Approved"
            />
            <Tab
              className="focus:outline-none dark:text-gray-300"
              sx={{ "&.Mui-selected": { color: "#057a55", outline: "none" } }}
              label="All"
            />
          </Tabs>
          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length > 0 ? (
              <TableContainer
                style={{
                  maxHeight: "65vh",
                  overflow: "scroll",
                  scrollbarWidth: "thin",
                }}
              >
                <Table>
                  <TableHeader className="custom-table-header text-center capitalize sticky top-0 z-10">
                    <tr>
                      <TableCell>Sl.No.</TableCell>
                      <TableCell>Ref No.</TableCell>

                      <TableCell>Client Name</TableCell>
                      <TableCell>Travel Date</TableCell>
                      {hideEdit && <TableCell>Itinerary</TableCell>}
                      <TableCell>Transporter</TableCell>

                      <TableCell>Trip Advance </TableCell>
                      <TableCell>TDS</TableCell>
                      <TableCell>Bill Amount</TableCell>
                      <TableCell>Bill Added Days</TableCell>
                      <TableCell>Remaining Individual Payable</TableCell>
                      <TableCell>Bill</TableCell>
                      <TableCell>Actions</TableCell>
                    </tr>
                  </TableHeader>
                  <BillApprovalTable
                    billapproval={dataTable}
                    billAmount={dataTable?.bill_amount}
                    id_client={dataTable?.id_client}
                    va_id={dataTable?.va_id}
                    perpage={itemsPerPage}
                    currentPage={currentPage}
                    tab={tab}
                    hideEdit={hideEdit}
                  />
                </Table>
              </TableContainer>
            ) : (
              <>
                {status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bill Details Approval." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default BillApproval;
